export default {
  path: "/videos",
  name: "videos",
  component: () => import("../pages/index.vue")
};
